import React from "react";
import styled, { css } from "styled-components";
import ItemPosition from "components/item/ItemPosition";

const ErrorLayout = ({ className, icon, title, desc, button }) => {
  return (
    <ErrorContainer className={className}>
      {icon && <Icon className="icon">{icon}</Icon>}
      {(title || desc) && (
        <Content className="content">
          {title && <Title>{title}</Title>}
          {desc?.length !== 0 &&
            desc?.map((el, idx) => <Desc key={idx.toString()}>{el}</Desc>)}
        </Content>
      )}
      {button && <ItemPosition position="center">{button}</ItemPosition>}
    </ErrorContainer>
  );
};

export default ErrorLayout;

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 42px 0;

  // 각 조건에 따른 스타일 처리
  ${({ className }) => errorClassName[className] || ""}
`;

const Icon = styled.div`
  font-size: 40px;
  color: ${({ theme }) => theme.color.gray200};
`;

const Content = styled.div`
  // margin: 16px 0 32px;
  margin: 16px 0;
`;

const Title = styled.h4`
  margin-bottom: 12px;
  font-weight: 600;
`;

const Desc = styled.p`
  font-size: 15px;
  color: ${({ theme }) => theme.color.gray500};
`;

const errorClassName = {
  no_search_error: css`
    .icon {
      font-size: 30px;
    }
    h4 {
      font-size: 15px;
      font-weight: 500;
    }
    p {
      font-size: 11px;
    }
  `,
  sample_error: css`
    .icon {
      color: ${({ theme }) => theme.color.primary};
    }
  `,
};
